'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _select = require('../basic/select');

var _select2 = _interopRequireDefault(_select);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Option = _select2["default"].Option;
var OptGroup = _select2["default"].OptGroup;


var Select = _react2["default"].createClass({
	displayName: 'Select',
	getDefaultProps: function getDefaultProps() {
		return {};
	},
	getInitialState: function getInitialState() {
		return {};
	},
	renderSelect: function renderSelect() {
		var data = [];
		if (this.props.data) {
			for (var i in this.props.data) {
				if (typeof this.props.data[i].value != "undefined") {
					data.push(_react2["default"].createElement(
						Option,
						_extends({ value: this.props.data[i].value, disabled: this.props.data[i].disabled ? true : false }, this.props.data[i].extra, { key: this.props.data[i].value }),
						' ',
						this.props.data[i].text,
						' '
					));
				} else {
					data.push(_react2["default"].createElement(
						Option,
						{ value: i, key: i },
						this.props.data[i]
					));
				}
			}
		}
		return _react2["default"].createElement(
			_select2["default"],
			_extends({}, this.props, { onChange: this.props.onChange }),
			data.length == 0 ? this.props.children : data
		);
	},
	renderLabledSelect: function renderLabledSelect(children) {
		var _classNames;

		var prefixCls = 'ant-input';
		var props = this.props;
		var wrapperClassName = prefixCls + '-group';
		var addonClassName = wrapperClassName + '-addon';
		var addonBefore = props.addonBefore ? _react2["default"].createElement(
			'span',
			{ className: addonClassName },
			props.addonBefore
		) : null;
		var className = (0, _classnames2["default"])((_classNames = {}, _defineProperty(_classNames, props.prefixCls + '-wrapper', true), _defineProperty(_classNames, wrapperClassName, addonBefore), _classNames));
		return _react2["default"].createElement(
			'span',
			{ className: className },
			addonBefore,
			children
		);
	},
	render: function render() {
		return this.props.addonBefore ? this.renderLabledSelect(this.renderSelect()) : this.renderSelect();
	}
});

Select.Option = Option;
Select.OptGroup = OptGroup;

exports["default"] = Select;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/business/select.jsx
 ** module id = 621
 ** module chunks = 0
 **/